<template>
  <header
    data-testid="base-header"
    class="base-header"
    :class="{ 'base-header--primary': primary }"
  >
    <ContainerMain>
      <div class="base-header__wrap">
        <router-link
          data-testid="base-header-logo"
          class="base-header__logo"
          to="/"
        >
          <TalentLogo :theme="activeTheme" />
        </router-link>

        <div
          v-if="!hideControls"
          class="base-header__right"
        >
          <ThemeSwitcher
            class="hide-phone"
            :theme="theme"
            @switch-theme="switchTheme"
          />

          <TalentUserMenu
            :theme="theme"
            @switch-theme="switchTheme"
          />
        </div>
      </div>
    </ContainerMain>
  </header>
</template>

<script>
import ContainerMain from '@/components/common/ContainerMain.vue'
import TalentUserMenu from '@/components/nav/TalentUserMenu.vue'
import ThemeSwitcher from '@/components/theme/ThemeSwitcher.vue'
import TalentLogo from '@/components/icons/TalentLogo.vue'

export default {
  name: 'TalentHeader',
  components: {
    ContainerMain,
    TalentUserMenu,
    TalentLogo,
    ThemeSwitcher
  },
  props: {
    theme: {
      type: String,
      default: 'light'
    },
    primary: {
      type: Boolean,
      default: false
    },
    hideControls: {
      type: Boolean,
      default: false
    }
  },
  emits: ['switchTheme'],
  computed: {
    activeTheme() {
      const { primary, theme } = this
      return primary ? 'dark' : theme
    }
  },
  methods: {
    switchTheme(theme) {
      this.$emit('switchTheme', theme)
    }
  }
}
</script>

<style scoped lang="scss">
.base-header {
  padding: var(--space-20) 0;
  background-color: var(--color-white);

  &.base-header--primary {
    background-color: var(--color-brand-500);
  }

  .base-header__wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .base-header__logo {
    display: block;
    width: 147px;
    fill: var(--color-brand-700);

    svg {
      width: 100%;
    }
  }

  .base-header__right {
    display: flex;
    align-items: center;
    gap: var(--space-32);
  }

  @include phone {
    padding: var(--space-16) 0;

    .base-header__logo {
      width: 155px;
    }
  }
}
</style>
